import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Portfolio.css";

export default function Portfolio() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t("portfolio.helmetTitle")} - Alfasol`;
  }, [t]);

  

  return (
    <div className="portfolio-container">
      <h1>{t("portfolio.title")}</h1>
      <p className="portfolio-coming-soon">{t("portfolio.comingSoon")}</p>
    </div>
  );
}